export default function StrongB2BSeller() {
  const traits = [
    {
      title: 'Мышление консультанта, а не продавца',
      desc: 'Сильный B2B-продавец не «впаривает» продукт. Он диагностирует бизнес клиента, выявляет проблемы и предлагает решение, которое приносит измеримый результат. Клиент воспринимает его как эксперта, которому доверяют.',
    },
    {
      title: 'Понимание бизнеса клиента',
      desc: 'Он знает отрасль клиента, его бизнес-модель, рынок, конкурентов и ключевые метрики. Говорит на языке CEO и финансового директора, а не на языке характеристик продукта.',
    },
    {
      title: 'Умение считать экономику сделки',
      desc: 'Оперирует цифрами: ROI, TCO, срок окупаемости, влияние на маржинальность. Может построить финансовую модель выгоды клиента от сотрудничества.',
    },
    {
      title: 'Мастерство переговоров',
      desc: 'Готовится к каждой встрече: цели, интересы ЛПР, аргументация, возможные возражения. Управляет ходом переговоров, а не реагирует. Завершает встречу чётким следующим шагом.',
    },
    {
      title: 'Создание доверия',
      desc: 'Доверие в B2B строится не на харизме, а на компетентности, последовательности и способности выполнять обещания. Сильный продавец инвестирует в долгосрочные отношения.',
    },
    {
      title: 'Работа с несколькими ЛПР',
      desc: 'Понимает, кто в компании клиента принимает решение, кто влияет, кто может заблокировать. Выстраивает стратегию influence для каждого. Не кладёт все яйца в одну корзину.',
    },
    {
      title: 'Ведение сделки месяцами',
      desc: 'Не теряет фокус при длинном цикле. Систематически касается клиента, добавляя ценность на каждом этапе. Управляет воронкой, а не ждёт.',
    },
    {
      title: 'Системность',
      desc: 'Работает по стандартам: подготовка, проведение, follow-up. Ведёт CRM. Его действия можно повторить — а значит, можно обучить других.',
    },
    {
      title: 'Follow-up как привычка',
      desc: 'После каждой встречи и КП — следующий шаг. Нет «зависших» сделок. Клиент всегда знает, что будет дальше, потому что продавец ведёт процесс.',
    },
    {
      title: 'Личная ответственность за результат',
      desc: 'Не перекладывает вину на «продукт не тот», «клиент не готов», «конкуренты дешевле». Ищет способы выиграть сделку, а не причины её проиграть.',
    },
  ];

  const comparison = [
    { label: 'Продавец товара', items: ['Презентует продукт', 'Говорит о характеристиках', 'Ждёт решения клиента', 'Даёт скидку при возражении', 'Работает с одним контактом', 'Продаёт «здесь и сейчас»'], type: 'bad' },
    { label: 'Бизнес-консультант', items: ['Диагностирует бизнес', 'Говорит о результате', 'Управляет процессом', 'Защищает ценность', 'Работает с картой ЛПР', 'Строит партнёрство'], type: 'good' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-gray-100 text-gray-600 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-article-line"></i>
            Экспертный материал
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Что отличает сильного B2B продавца
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            B2B-продажи требуют принципиально другого мышления и набора компетенций. Вот ключевые отличия.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 mb-16 max-w-5xl mx-auto">
          {comparison.map((col, ci) => (
            <div key={ci} className={col.type === 'bad' ? 'bg-white rounded-2xl p-6 md:p-8 border border-red-100' : 'bg-white rounded-2xl p-6 md:p-8 border border-teal-100'}>
              <div className={`flex items-center gap-3 mb-6 ${col.type === 'bad' ? '' : ''}`}>
                <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${col.type === 'bad' ? 'bg-red-100' : 'bg-teal-600'}`}>
                  <i className={`text-lg ${col.type === 'bad' ? 'ri-close-line text-red-500' : 'ri-check-line text-white'}`}></i>
                </div>
                <h3 className={`text-lg font-bold ${col.type === 'bad' ? 'text-red-700' : 'text-teal-700'}`}>{col.label}</h3>
              </div>
              <div className="space-y-3">
                {col.items.map((item, j) => (
                  <div key={j} className={`flex items-center gap-3 rounded-lg p-3 ${col.type === 'bad' ? 'bg-red-50' : 'bg-teal-50'}`}>
                    <div className={`w-2 h-2 rounded-full flex-shrink-0 ${col.type === 'bad' ? 'bg-red-400' : 'bg-teal-500'}`}></div>
                    <span className="text-sm text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="max-w-5xl mx-auto">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">10 ключевых компетенций B2B-продавца</h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {traits.map((item, i) => (
              <div key={i} className="bg-white rounded-xl p-5 md:p-6 border border-gray-100 hover:border-teal-100 transition-colors group">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-8 h-8 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold text-xs">{String(i + 1).padStart(2, '0')}</span>
                  </div>
                  <h4 className="text-base font-semibold text-gray-900">{item.title}</h4>
                </div>
                <p className="text-sm text-gray-600 leading-relaxed pl-11">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}